module.exports = __webpack_public_path__ + "static/media/nav-logout.d17a78b8.svg";